import * as React from 'react'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from './GlobalSearchContexts'
import type { GlobalSearchAction } from './GlobalSearchState'
import type GlobalSearchState from './GlobalSearchState'
import ModalProvider from 'contexts/ModalProvider'
import { useReportContextToDevPanel } from 'components/App/DevPanel/hooks'

interface Props {
  children: React.ReactNode
  dispatch: React.Dispatch<GlobalSearchAction>
  state: GlobalSearchState
}

export default function GlobalSearchContextProvider(props: Props) {
  const { children, dispatch, state } = props

  useReportContextToDevPanel('GlobalSearchStateContext', state)

  return <GlobalSearchStateContext.Provider value={state}>
    <GlobalSearchDispatchContext.Provider value={dispatch}>
      <ModalProvider>
        {children}
      </ModalProvider>
    </GlobalSearchDispatchContext.Provider>
  </GlobalSearchStateContext.Provider>
}
